module.exports = __webpack_public_path__ + "img/404.3b45d178.png";